module.exports = __webpack_public_path__ + "static/media/threeLines.f1dd0938.svg";